import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { secondaryColor, textColor } from 'app-constants';

export const Icons = (props) => {
  const { className, variant, onClick, testid, color } = props;

  const getIcons = () => {
    switch (variant) {
      case Icons.CONDO: {
        return (
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 8C0 3.58172 3.58172 0 8 0H36C40.4183 0 44 3.58172 44 8V36C44 40.4183 40.4183 44 36 44H8C3.58172 44 0 40.4183 0 36V8Z"
              fill="#F4F5F6"
            />
            <path
              d="M26 33V11H11V33H26ZM26 33H33.9976V18L25.9976 16"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 33V28H21V33"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 15.5C15 15.2239 15.2239 15 15.5 15H16.5C16.7761 15 17 15.2239 17 15.5V16.5C17 16.7761 16.7761 17 16.5 17H15.5C15.2239 17 15 16.7761 15 16.5V15.5Z"
              fill="#515151"
            />
            <path
              d="M15 19.5C15 19.2239 15.2239 19 15.5 19H16.5C16.7761 19 17 19.2239 17 19.5V20.5C17 20.7761 16.7761 21 16.5 21H15.5C15.2239 21 15 20.7761 15 20.5V19.5Z"
              fill="#515151"
            />
            <path
              d="M15 23.5C15 23.2239 15.2239 23 15.5 23H16.5C16.7761 23 17 23.2239 17 23.5V24.5C17 24.7761 16.7761 25 16.5 25H15.5C15.2239 25 15 24.7761 15 24.5V23.5Z"
              fill="#515151"
            />
            <path
              d="M20 15.5C20 15.2239 20.2239 15 20.5 15H21.5C21.7761 15 22 15.2239 22 15.5V16.5C22 16.7761 21.7761 17 21.5 17H20.5C20.2239 17 20 16.7761 20 16.5V15.5Z"
              fill="#515151"
            />
            <path
              d="M20 19.5C20 19.2239 20.2239 19 20.5 19H21.5C21.7761 19 22 19.2239 22 19.5V20.5C22 20.7761 21.7761 21 21.5 21H20.5C20.2239 21 20 20.7761 20 20.5V19.5Z"
              fill="#515151"
            />
            <path
              d="M20 23.5C20 23.2239 20.2239 23 20.5 23H21.5C21.7761 23 22 23.2239 22 23.5V24.5C22 24.7761 21.7761 25 21.5 25H20.5C20.2239 25 20 24.7761 20 24.5V23.5Z"
              fill="#515151"
            />
            <path
              d="M29 20.5C29 20.2239 29.2239 20 29.5 20H30.5C30.7761 20 31 20.2239 31 20.5V21.5C31 21.7761 30.7761 22 30.5 22H29.5C29.2239 22 29 21.7761 29 21.5V20.5Z"
              fill="#515151"
            />
            <path
              d="M29 24.5C29 24.2239 29.2239 24 29.5 24H30.5C30.7761 24 31 24.2239 31 24.5V25.5C31 25.7761 30.7761 26 30.5 26H29.5C29.2239 26 29 25.7761 29 25.5V24.5Z"
              fill="#515151"
            />
            <path
              d="M29 28.5C29 28.2239 29.2239 28 29.5 28H30.5C30.7761 28 31 28.2239 31 28.5V29.5C31 29.7761 30.7761 30 30.5 30H29.5C29.2239 30 29 29.7761 29 29.5V28.5Z"
              fill="#515151"
            />
          </svg>
        );
      }
      case Icons.EDIT: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 14H5.13144L13.3515 5.77998C13.7667 5.36472 14 4.80152 14 4.21426C14 3.627 13.7667 3.0638 13.3515 2.64854C12.9362 2.23329 12.373 2 11.7857 2C11.1985 2 10.6353 2.23329 10.22 2.64854L2 10.8686V14Z"
              stroke={color ?? textColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.43683 3.43164L12.5683 6.56308"
              stroke={color ?? textColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.COPY: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.6367 4L17.364 4C17.8944 4 18.4031 4.21071 18.7782 4.58579C19.1533 4.96086 19.364 5.46957 19.364 6V15C19.364 15.5304 19.1533 16.0391 18.7782 16.4142C18.4031 16.7893 17.8944 17 17.364 17H10.6367C10.1063 17 9.59758 16.7893 9.22251 16.4142C8.84743 16.0391 8.63672 15.5304 8.63672 15V6C8.63672 5.46957 8.84743 4.96086 9.22251 4.58579C9.59758 4.21071 10.1063 4 10.6367 4Z"
              stroke="#181D2C"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.364 17V19C15.364 19.5304 15.1533 20.0391 14.7782 20.4142C14.4031 20.7893 13.8944 21 13.364 21H6.63672C6.10629 21 5.59758 20.7893 5.22251 20.4142C4.84743 20.0391 4.63672 19.5304 4.63672 19V10C4.63672 9.46957 4.84743 8.96086 5.22251 8.58579C5.59758 8.21071 6.10629 8 6.63672 8H8.63672"
              stroke="#181D2C"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.DELETE: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.00098 7H20.001"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.001 11V17"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.999 11V17"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.99902 7L5.99902 19C5.99902 19.5304 6.20974 20.0391 6.58481 20.4142C6.95988 20.7893 7.46859 21 7.99902 21H15.999C16.5295 21 17.0382 20.7893 17.4132 20.4142C17.7883 20.0391 17.999 19.5304 17.999 19L18.999 7"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 7V4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V7"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.ADD: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8Z"
              fill="#FF576D"
            />
          </svg>
        );
      }
      case Icons.REMOVE: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13H11H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11H13Z"
              fill="#FF576D"
            />
          </svg>
        );
      }
      case Icons.CHECKMARK: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33252 7.99935L6.66585 11.3327L13.3325 4.66602"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.SHOWINGS: {
        return (
          <svg
            width="148"
            height="81"
            viewBox="0 0 148 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <path
                d="M0.5 44C0.5 42.067 2.067 40.5 4 40.5H144C145.933 40.5 147.5 42.067 147.5 44V77C147.5 78.933 145.933 80.5 144 80.5H4C2.067 80.5 0.5 78.933 0.5 77V44Z"
                fill="white"
              />
              <path
                d="M0.5 44C0.5 42.067 2.067 40.5 4 40.5H144C145.933 40.5 147.5 42.067 147.5 44V77C147.5 78.933 145.933 80.5 144 80.5H4C2.067 80.5 0.5 78.933 0.5 77V44Z"
                fill="#F9FBFB"
              />
              <path
                d="M0.5 44C0.5 42.067 2.067 40.5 4 40.5H144C145.933 40.5 147.5 42.067 147.5 44V77C147.5 78.933 145.933 80.5 144 80.5H4C2.067 80.5 0.5 78.933 0.5 77V44Z"
                stroke="#D6D6D6"
              />
              <path
                d="M0 42C0 40.8954 0.895431 40 2 40V81C0.895431 81 0 80.1046 0 79V42Z"
                fill="#2B59DA"
              />
              <path
                opacity="0.6"
                d="M14.6697 54.7266C14.6366 54.4164 14.4969 54.175 14.2507 54.0021C14.0069 53.8293 13.6896 53.7429 13.299 53.7429C13.0244 53.7429 12.7888 53.7843 12.5923 53.8672C12.3958 53.95 12.2455 54.0625 12.1413 54.2045C12.0372 54.3466 11.9839 54.5088 11.9815 54.6911C11.9815 54.8426 12.0159 54.974 12.0845 55.0852C12.1555 55.1965 12.2514 55.2912 12.3722 55.3693C12.4929 55.4451 12.6267 55.509 12.7734 55.5611C12.9202 55.6132 13.0682 55.657 13.2173 55.6925L13.8991 55.8629C14.1738 55.9268 14.4377 56.0133 14.6911 56.1222C14.9467 56.2311 15.1752 56.3684 15.3764 56.5341C15.58 56.6998 15.741 56.8999 15.8594 57.1342C15.9777 57.3686 16.0369 57.6432 16.0369 57.9581C16.0369 58.3842 15.928 58.7595 15.7102 59.0838C15.4924 59.4058 15.1776 59.6579 14.7656 59.8402C14.3561 60.0201 13.8601 60.1101 13.2777 60.1101C12.7119 60.1101 12.2206 60.0225 11.804 59.8473C11.3897 59.6721 11.0653 59.4164 10.831 59.0803C10.599 58.7441 10.4735 58.3345 10.4545 57.8516H11.7507C11.7696 58.1049 11.8478 58.3156 11.9851 58.4837C12.1224 58.6518 12.3011 58.7772 12.5213 58.8601C12.7438 58.9429 12.9924 58.9844 13.267 58.9844C13.5535 58.9844 13.8045 58.9418 14.0199 58.8565C14.2377 58.7689 14.4081 58.6482 14.5312 58.4943C14.6544 58.3381 14.7171 58.1558 14.7195 57.9474C14.7171 57.758 14.6615 57.6018 14.5526 57.4787C14.4437 57.3532 14.291 57.2491 14.0945 57.1662C13.9003 57.081 13.6731 57.0052 13.4126 56.9389L12.5852 56.7259C11.9863 56.572 11.5128 56.3388 11.1648 56.0263C10.8191 55.7114 10.6463 55.2936 10.6463 54.7727C10.6463 54.3442 10.7623 53.969 10.9943 53.647C11.2287 53.325 11.5471 53.0753 11.9496 52.8977C12.352 52.7178 12.8078 52.6278 13.3168 52.6278C13.8329 52.6278 14.285 52.7178 14.6733 52.8977C15.0639 53.0753 15.3705 53.3227 15.593 53.6399C15.8156 53.9548 15.9304 54.317 15.9375 54.7266H14.6697ZM18.2602 56.804V60H16.9747V52.7273H18.2318V55.4723H18.2957C18.4235 55.1645 18.6212 54.9219 18.8887 54.7443C19.1586 54.5644 19.5019 54.4744 19.9185 54.4744C20.2973 54.4744 20.6276 54.5537 20.9093 54.7124C21.191 54.871 21.4088 55.103 21.5627 55.4084C21.719 55.7138 21.7971 56.0866 21.7971 56.527V60H20.5116V56.7259C20.5116 56.3589 20.4169 56.0736 20.2275 55.87C20.0405 55.6641 19.7777 55.5611 19.4391 55.5611C19.2119 55.5611 19.0083 55.6108 18.8283 55.7102C18.6508 55.8073 18.5111 55.9482 18.4093 56.1328C18.3099 56.3175 18.2602 56.5412 18.2602 56.804ZM25.3067 60.1065C24.7741 60.1065 24.3124 59.9893 23.9218 59.755C23.5312 59.5206 23.2281 59.1927 23.0127 58.7713C22.7996 58.3499 22.6931 57.8575 22.6931 57.294C22.6931 56.7306 22.7996 56.237 23.0127 55.8132C23.2281 55.3894 23.5312 55.0604 23.9218 54.826C24.3124 54.5916 24.7741 54.4744 25.3067 54.4744C25.8394 54.4744 26.301 54.5916 26.6917 54.826C27.0823 55.0604 27.3841 55.3894 27.5972 55.8132C27.8126 56.237 27.9204 56.7306 27.9204 57.294C27.9204 57.8575 27.8126 58.3499 27.5972 58.7713C27.3841 59.1927 27.0823 59.5206 26.6917 59.755C26.301 59.9893 25.8394 60.1065 25.3067 60.1065ZM25.3138 59.0767C25.6027 59.0767 25.8441 58.9974 26.0383 58.8388C26.2324 58.6778 26.3768 58.4624 26.4715 58.1925C26.5686 57.9226 26.6171 57.6219 26.6171 57.2905C26.6171 56.9567 26.5686 56.6548 26.4715 56.3849C26.3768 56.1127 26.2324 55.8961 26.0383 55.7351C25.8441 55.5741 25.6027 55.4936 25.3138 55.4936C25.0179 55.4936 24.7717 55.5741 24.5752 55.7351C24.3811 55.8961 24.2355 56.1127 24.1384 56.3849C24.0437 56.6548 23.9964 56.9567 23.9964 57.2905C23.9964 57.6219 24.0437 57.9226 24.1384 58.1925C24.2355 58.4624 24.3811 58.6778 24.5752 58.8388C24.7717 58.9974 25.0179 59.0767 25.3138 59.0767ZM29.8009 60L28.2597 54.5455H29.5701L30.5289 58.3807H30.5786L31.5587 54.5455H32.8549L33.835 58.3594H33.8883L34.8329 54.5455H36.1468L34.602 60H33.2633L32.2405 56.3139H32.166L31.1432 60H29.8009ZM36.8643 60V54.5455H38.1499V60H36.8643ZM37.5106 53.7713C37.307 53.7713 37.1319 53.7038 36.9851 53.5689C36.8383 53.4316 36.7649 53.267 36.7649 53.0753C36.7649 52.8812 36.8383 52.7166 36.9851 52.5817C37.1319 52.4444 37.307 52.3757 37.5106 52.3757C37.7166 52.3757 37.8918 52.4444 38.0362 52.5817C38.183 52.7166 38.2564 52.8812 38.2564 53.0753C38.2564 53.267 38.183 53.4316 38.0362 53.5689C37.8918 53.7038 37.7166 53.7713 37.5106 53.7713ZM40.5773 56.804V60H39.2918V54.5455H40.5205V55.4723H40.5844C40.7098 55.1669 40.9099 54.9242 41.1845 54.7443C41.4615 54.5644 41.8036 54.4744 42.2108 54.4744C42.5872 54.4744 42.9151 54.5549 43.1945 54.7159C43.4762 54.8769 43.694 55.1101 43.8479 55.4155C44.0041 55.7209 44.0811 56.0914 44.0787 56.527V60H42.7932V56.7259C42.7932 56.3613 42.6985 56.076 42.5091 55.87C42.3221 55.6641 42.0628 55.5611 41.7314 55.5611C41.5065 55.5611 41.3064 55.6108 41.1313 55.7102C40.9584 55.8073 40.8223 55.9482 40.7229 56.1328C40.6258 56.3175 40.5773 56.5412 40.5773 56.804ZM47.5777 62.1591C47.116 62.1591 46.7195 62.0964 46.388 61.9709C46.0566 61.8478 45.7903 61.6821 45.589 61.4737C45.3878 61.2654 45.2481 61.0346 45.17 60.7812L46.3277 60.5007C46.3798 60.6072 46.4555 60.7126 46.5549 60.8168C46.6544 60.9233 46.7881 61.0109 46.9562 61.0795C47.1267 61.1506 47.3409 61.1861 47.599 61.1861C47.9636 61.1861 48.2654 61.0973 48.5045 60.9197C48.7436 60.7446 48.8632 60.4557 48.8632 60.0533V59.0199H48.7993C48.733 59.1525 48.6359 59.2886 48.5081 59.4283C48.3826 59.5679 48.2157 59.6851 48.0074 59.7798C47.8014 59.8745 47.5422 59.9219 47.2297 59.9219C46.8106 59.9219 46.4307 59.8236 46.0897 59.6271C45.7512 59.4283 45.4813 59.1323 45.2801 58.7393C45.0812 58.344 44.9818 57.8492 44.9818 57.255C44.9818 56.656 45.0812 56.1506 45.2801 55.7386C45.4813 55.3243 45.7524 55.0107 46.0933 54.7976C46.4342 54.5821 46.8142 54.4744 47.2332 54.4744C47.5528 54.4744 47.8156 54.5289 48.0216 54.6378C48.2299 54.7443 48.3956 54.8733 48.5187 55.0249C48.6418 55.174 48.7353 55.3149 48.7993 55.4474H48.8703V54.5455H50.138V60.0888C50.138 60.5552 50.0268 60.9411 49.8042 61.2464C49.5817 61.5518 49.2775 61.7803 48.8916 61.9318C48.5057 62.0833 48.0677 62.1591 47.5777 62.1591ZM47.5883 58.9134C47.8606 58.9134 48.0926 58.8471 48.2843 58.7145C48.4761 58.5819 48.6217 58.3913 48.7211 58.1428C48.8206 57.8942 48.8703 57.5959 48.8703 57.2479C48.8703 56.9046 48.8206 56.6039 48.7211 56.3459C48.6241 56.0878 48.4797 55.8878 48.2879 55.7457C48.0985 55.6013 47.8653 55.5291 47.5883 55.5291C47.3019 55.5291 47.0628 55.6037 46.871 55.7528C46.6792 55.902 46.5348 56.1068 46.4378 56.3672C46.3407 56.6252 46.2922 56.9188 46.2922 57.2479C46.2922 57.5817 46.3407 57.8741 46.4378 58.125C46.5372 58.3736 46.6828 58.5677 46.8745 58.7074C47.0687 58.8447 47.3066 58.9134 47.5883 58.9134ZM53.5618 60V59.0483L56.0866 56.5732C56.3281 56.3293 56.5293 56.1127 56.6903 55.9233C56.8513 55.7339 56.9721 55.5504 57.0525 55.3729C57.133 55.1953 57.1733 55.0059 57.1733 54.8047C57.1733 54.575 57.1212 54.3786 57.017 54.2152C56.9129 54.0495 56.7696 53.9216 56.5873 53.8317C56.4051 53.7417 56.1979 53.6967 55.9659 53.6967C55.7268 53.6967 55.5173 53.7464 55.3373 53.8459C55.1574 53.9429 55.0177 54.0814 54.9183 54.2614C54.8212 54.4413 54.7727 54.6555 54.7727 54.9041H53.5192C53.5192 54.4425 53.6245 54.0412 53.8352 53.7003C54.0459 53.3594 54.3359 53.0954 54.7052 52.9084C55.0769 52.7214 55.5031 52.6278 55.9837 52.6278C56.4713 52.6278 56.8998 52.719 57.2692 52.9013C57.6385 53.0836 57.9249 53.3333 58.1285 53.6506C58.3345 53.9678 58.4375 54.33 58.4375 54.7372C58.4375 55.0095 58.3854 55.277 58.2812 55.5398C58.1771 55.8026 57.9936 56.0937 57.7308 56.4134C57.4704 56.733 57.1046 57.12 56.6335 57.5746L55.38 58.8494V58.8991H58.5476V60H53.5618Z"
                fill="#181D2C"
              />
              <g opacity="0.6">
                <path
                  d="M135.375 51.5H128.625C128.004 51.5 127.5 52.0037 127.5 52.625V59.375C127.5 59.9963 128.004 60.5 128.625 60.5H135.375C135.996 60.5 136.5 59.9963 136.5 59.375V52.625C136.5 52.0037 135.996 51.5 135.375 51.5Z"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M134.25 50.75V52.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M129.75 50.75V52.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M127.5 54.5H136.5"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <path
                d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H144C145.933 0.5 147.5 2.067 147.5 4V37C147.5 38.933 145.933 40.5 144 40.5H4C2.067 40.5 0.5 38.933 0.5 37V4Z"
                fill="white"
              />
              <path
                d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H144C145.933 0.5 147.5 2.067 147.5 4V37C147.5 38.933 145.933 40.5 144 40.5H4C2.067 40.5 0.5 38.933 0.5 37V4Z"
                fill="#F9FBFB"
              />
              <path
                d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H144C145.933 0.5 147.5 2.067 147.5 4V37C147.5 38.933 145.933 40.5 144 40.5H4C2.067 40.5 0.5 38.933 0.5 37V4Z"
                stroke="#D6D6D6"
              />
              <path
                d="M0 2C0 0.895431 0.895431 0 2 0V41C0.895431 41 0 40.1046 0 39V2Z"
                fill="#2B59DA"
              />
              <path
                opacity="0.6"
                d="M14.6697 14.7266C14.6366 14.4164 14.4969 14.175 14.2507 14.0021C14.0069 13.8293 13.6896 13.7429 13.299 13.7429C13.0244 13.7429 12.7888 13.7843 12.5923 13.8672C12.3958 13.95 12.2455 14.0625 12.1413 14.2045C12.0372 14.3466 11.9839 14.5088 11.9815 14.6911C11.9815 14.8426 12.0159 14.974 12.0845 15.0852C12.1555 15.1965 12.2514 15.2912 12.3722 15.3693C12.4929 15.4451 12.6267 15.509 12.7734 15.5611C12.9202 15.6132 13.0682 15.657 13.2173 15.6925L13.8991 15.8629C14.1738 15.9268 14.4377 16.0133 14.6911 16.1222C14.9467 16.2311 15.1752 16.3684 15.3764 16.5341C15.58 16.6998 15.741 16.8999 15.8594 17.1342C15.9777 17.3686 16.0369 17.6432 16.0369 17.9581C16.0369 18.3842 15.928 18.7595 15.7102 19.0838C15.4924 19.4058 15.1776 19.6579 14.7656 19.8402C14.3561 20.0201 13.8601 20.1101 13.2777 20.1101C12.7119 20.1101 12.2206 20.0225 11.804 19.8473C11.3897 19.6721 11.0653 19.4164 10.831 19.0803C10.599 18.7441 10.4735 18.3345 10.4545 17.8516H11.7507C11.7696 18.1049 11.8478 18.3156 11.9851 18.4837C12.1224 18.6518 12.3011 18.7772 12.5213 18.8601C12.7438 18.9429 12.9924 18.9844 13.267 18.9844C13.5535 18.9844 13.8045 18.9418 14.0199 18.8565C14.2377 18.7689 14.4081 18.6482 14.5312 18.4943C14.6544 18.3381 14.7171 18.1558 14.7195 17.9474C14.7171 17.758 14.6615 17.6018 14.5526 17.4787C14.4437 17.3532 14.291 17.2491 14.0945 17.1662C13.9003 17.081 13.6731 17.0052 13.4126 16.9389L12.5852 16.7259C11.9863 16.572 11.5128 16.3388 11.1648 16.0263C10.8191 15.7114 10.6463 15.2936 10.6463 14.7727C10.6463 14.3442 10.7623 13.969 10.9943 13.647C11.2287 13.325 11.5471 13.0753 11.9496 12.8977C12.352 12.7178 12.8078 12.6278 13.3168 12.6278C13.8329 12.6278 14.285 12.7178 14.6733 12.8977C15.0639 13.0753 15.3705 13.3227 15.593 13.6399C15.8156 13.9548 15.9304 14.317 15.9375 14.7266H14.6697ZM18.2602 16.804V20H16.9747V12.7273H18.2318V15.4723H18.2957C18.4235 15.1645 18.6212 14.9219 18.8887 14.7443C19.1586 14.5644 19.5019 14.4744 19.9185 14.4744C20.2973 14.4744 20.6276 14.5537 20.9093 14.7124C21.191 14.871 21.4088 15.103 21.5627 15.4084C21.719 15.7138 21.7971 16.0866 21.7971 16.527V20H20.5116V16.7259C20.5116 16.3589 20.4169 16.0736 20.2275 15.87C20.0405 15.6641 19.7777 15.5611 19.4391 15.5611C19.2119 15.5611 19.0083 15.6108 18.8283 15.7102C18.6508 15.8073 18.5111 15.9482 18.4093 16.1328C18.3099 16.3175 18.2602 16.5412 18.2602 16.804ZM25.3067 20.1065C24.7741 20.1065 24.3124 19.9893 23.9218 19.755C23.5312 19.5206 23.2281 19.1927 23.0127 18.7713C22.7996 18.3499 22.6931 17.8575 22.6931 17.294C22.6931 16.7306 22.7996 16.237 23.0127 15.8132C23.2281 15.3894 23.5312 15.0604 23.9218 14.826C24.3124 14.5916 24.7741 14.4744 25.3067 14.4744C25.8394 14.4744 26.301 14.5916 26.6917 14.826C27.0823 15.0604 27.3841 15.3894 27.5972 15.8132C27.8126 16.237 27.9204 16.7306 27.9204 17.294C27.9204 17.8575 27.8126 18.3499 27.5972 18.7713C27.3841 19.1927 27.0823 19.5206 26.6917 19.755C26.301 19.9893 25.8394 20.1065 25.3067 20.1065ZM25.3138 19.0767C25.6027 19.0767 25.8441 18.9974 26.0383 18.8388C26.2324 18.6778 26.3768 18.4624 26.4715 18.1925C26.5686 17.9226 26.6171 17.6219 26.6171 17.2905C26.6171 16.9567 26.5686 16.6548 26.4715 16.3849C26.3768 16.1127 26.2324 15.8961 26.0383 15.7351C25.8441 15.5741 25.6027 15.4936 25.3138 15.4936C25.0179 15.4936 24.7717 15.5741 24.5752 15.7351C24.3811 15.8961 24.2355 16.1127 24.1384 16.3849C24.0437 16.6548 23.9964 16.9567 23.9964 17.2905C23.9964 17.6219 24.0437 17.9226 24.1384 18.1925C24.2355 18.4624 24.3811 18.6778 24.5752 18.8388C24.7717 18.9974 25.0179 19.0767 25.3138 19.0767ZM29.8009 20L28.2597 14.5455H29.5701L30.5289 18.3807H30.5786L31.5587 14.5455H32.8549L33.835 18.3594H33.8883L34.8329 14.5455H36.1468L34.602 20H33.2633L32.2405 16.3139H32.166L31.1432 20H29.8009ZM36.8643 20V14.5455H38.1499V20H36.8643ZM37.5106 13.7713C37.307 13.7713 37.1319 13.7038 36.9851 13.5689C36.8383 13.4316 36.7649 13.267 36.7649 13.0753C36.7649 12.8812 36.8383 12.7166 36.9851 12.5817C37.1319 12.4444 37.307 12.3757 37.5106 12.3757C37.7166 12.3757 37.8918 12.4444 38.0362 12.5817C38.183 12.7166 38.2564 12.8812 38.2564 13.0753C38.2564 13.267 38.183 13.4316 38.0362 13.5689C37.8918 13.7038 37.7166 13.7713 37.5106 13.7713ZM40.5773 16.804V20H39.2918V14.5455H40.5205V15.4723H40.5844C40.7098 15.1669 40.9099 14.9242 41.1845 14.7443C41.4615 14.5644 41.8036 14.4744 42.2108 14.4744C42.5872 14.4744 42.9151 14.5549 43.1945 14.7159C43.4762 14.8769 43.694 15.1101 43.8479 15.4155C44.0041 15.7209 44.0811 16.0914 44.0787 16.527V20H42.7932V16.7259C42.7932 16.3613 42.6985 16.076 42.5091 15.87C42.3221 15.6641 42.0628 15.5611 41.7314 15.5611C41.5065 15.5611 41.3064 15.6108 41.1313 15.7102C40.9584 15.8073 40.8223 15.9482 40.7229 16.1328C40.6258 16.3175 40.5773 16.5412 40.5773 16.804ZM47.5777 22.1591C47.116 22.1591 46.7195 22.0964 46.388 21.9709C46.0566 21.8478 45.7903 21.6821 45.589 21.4737C45.3878 21.2654 45.2481 21.0346 45.17 20.7812L46.3277 20.5007C46.3798 20.6072 46.4555 20.7126 46.5549 20.8168C46.6544 20.9233 46.7881 21.0109 46.9562 21.0795C47.1267 21.1506 47.3409 21.1861 47.599 21.1861C47.9636 21.1861 48.2654 21.0973 48.5045 20.9197C48.7436 20.7446 48.8632 20.4557 48.8632 20.0533V19.0199H48.7993C48.733 19.1525 48.6359 19.2886 48.5081 19.4283C48.3826 19.5679 48.2157 19.6851 48.0074 19.7798C47.8014 19.8745 47.5422 19.9219 47.2297 19.9219C46.8106 19.9219 46.4307 19.8236 46.0897 19.6271C45.7512 19.4283 45.4813 19.1323 45.2801 18.7393C45.0812 18.344 44.9818 17.8492 44.9818 17.255C44.9818 16.656 45.0812 16.1506 45.2801 15.7386C45.4813 15.3243 45.7524 15.0107 46.0933 14.7976C46.4342 14.5821 46.8142 14.4744 47.2332 14.4744C47.5528 14.4744 47.8156 14.5289 48.0216 14.6378C48.2299 14.7443 48.3956 14.8733 48.5187 15.0249C48.6418 15.174 48.7353 15.3149 48.7993 15.4474H48.8703V14.5455H50.138V20.0888C50.138 20.5552 50.0268 20.9411 49.8042 21.2464C49.5817 21.5518 49.2775 21.7803 48.8916 21.9318C48.5057 22.0833 48.0677 22.1591 47.5777 22.1591ZM47.5883 18.9134C47.8606 18.9134 48.0926 18.8471 48.2843 18.7145C48.4761 18.5819 48.6217 18.3913 48.7211 18.1428C48.8206 17.8942 48.8703 17.5959 48.8703 17.2479C48.8703 16.9046 48.8206 16.6039 48.7211 16.3459C48.6241 16.0878 48.4797 15.8878 48.2879 15.7457C48.0985 15.6013 47.8653 15.5291 47.5883 15.5291C47.3019 15.5291 47.0628 15.6037 46.871 15.7528C46.6792 15.902 46.5348 16.1068 46.4378 16.3672C46.3407 16.6252 46.2922 16.9188 46.2922 17.2479C46.2922 17.5817 46.3407 17.8741 46.4378 18.125C46.5372 18.3736 46.6828 18.5677 46.8745 18.7074C47.0687 18.8447 47.3066 18.9134 47.5883 18.9134ZM56.5199 12.7273V20H55.2024V14.0092H55.1598L53.4588 15.0959V13.8885L55.2663 12.7273H56.5199Z"
                fill="#181D2C"
              />
              <g opacity="0.6">
                <path
                  d="M135.375 11.5H128.625C128.004 11.5 127.5 12.0037 127.5 12.625V19.375C127.5 19.9963 128.004 20.5 128.625 20.5H135.375C135.996 20.5 136.5 19.9963 136.5 19.375V12.625C136.5 12.0037 135.996 11.5 135.375 11.5Z"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M134.25 10.75V12.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M129.75 10.75V12.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M127.5 14.5H136.5"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </svg>
        );
      }
      case Icons.BUFFER_BTW_SHOWINGS: {
        return (
          <svg
            width="148"
            height="106"
            viewBox="0 0 148 106"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <rect opacity="0.2" width="148" height="106" rx="4" fill="#2B59DA" />
              <path
                d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H144C145.933 0.5 147.5 2.067 147.5 4V37C147.5 38.933 145.933 40.5 144 40.5H4C2.067 40.5 0.5 38.933 0.5 37V4Z"
                fill="white"
              />
              <path
                d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H144C145.933 0.5 147.5 2.067 147.5 4V37C147.5 38.933 145.933 40.5 144 40.5H4C2.067 40.5 0.5 38.933 0.5 37V4Z"
                fill="#F9FBFB"
              />
              <path
                d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H144C145.933 0.5 147.5 2.067 147.5 4V37C147.5 38.933 145.933 40.5 144 40.5H4C2.067 40.5 0.5 38.933 0.5 37V4Z"
                stroke="#D6D6D6"
              />
              <path
                d="M0 2C0 0.895431 0.895431 0 2 0V41C0.895431 41 0 40.1046 0 39V2Z"
                fill="#2B59DA"
              />
              <path
                opacity="0.6"
                d="M14.6697 14.7266C14.6366 14.4164 14.4969 14.175 14.2507 14.0021C14.0069 13.8293 13.6896 13.7429 13.299 13.7429C13.0244 13.7429 12.7888 13.7843 12.5923 13.8672C12.3958 13.95 12.2455 14.0625 12.1413 14.2045C12.0372 14.3466 11.9839 14.5088 11.9815 14.6911C11.9815 14.8426 12.0159 14.974 12.0845 15.0852C12.1555 15.1965 12.2514 15.2912 12.3722 15.3693C12.4929 15.4451 12.6267 15.509 12.7734 15.5611C12.9202 15.6132 13.0682 15.657 13.2173 15.6925L13.8991 15.8629C14.1738 15.9268 14.4377 16.0133 14.6911 16.1222C14.9467 16.2311 15.1752 16.3684 15.3764 16.5341C15.58 16.6998 15.741 16.8999 15.8594 17.1342C15.9777 17.3686 16.0369 17.6432 16.0369 17.9581C16.0369 18.3842 15.928 18.7595 15.7102 19.0838C15.4924 19.4058 15.1776 19.6579 14.7656 19.8402C14.3561 20.0201 13.8601 20.1101 13.2777 20.1101C12.7119 20.1101 12.2206 20.0225 11.804 19.8473C11.3897 19.6721 11.0653 19.4164 10.831 19.0803C10.599 18.7441 10.4735 18.3345 10.4545 17.8516H11.7507C11.7696 18.1049 11.8478 18.3156 11.9851 18.4837C12.1224 18.6518 12.3011 18.7772 12.5213 18.8601C12.7438 18.9429 12.9924 18.9844 13.267 18.9844C13.5535 18.9844 13.8045 18.9418 14.0199 18.8565C14.2377 18.7689 14.4081 18.6482 14.5312 18.4943C14.6544 18.3381 14.7171 18.1558 14.7195 17.9474C14.7171 17.758 14.6615 17.6018 14.5526 17.4787C14.4437 17.3532 14.291 17.2491 14.0945 17.1662C13.9003 17.081 13.6731 17.0052 13.4126 16.9389L12.5852 16.7259C11.9863 16.572 11.5128 16.3388 11.1648 16.0263C10.8191 15.7114 10.6463 15.2936 10.6463 14.7727C10.6463 14.3442 10.7623 13.969 10.9943 13.647C11.2287 13.325 11.5471 13.0753 11.9496 12.8977C12.352 12.7178 12.8078 12.6278 13.3168 12.6278C13.8329 12.6278 14.285 12.7178 14.6733 12.8977C15.0639 13.0753 15.3705 13.3227 15.593 13.6399C15.8156 13.9548 15.9304 14.317 15.9375 14.7266H14.6697ZM18.2602 16.804V20H16.9747V12.7273H18.2318V15.4723H18.2957C18.4235 15.1645 18.6212 14.9219 18.8887 14.7443C19.1586 14.5644 19.5019 14.4744 19.9185 14.4744C20.2973 14.4744 20.6276 14.5537 20.9093 14.7124C21.191 14.871 21.4088 15.103 21.5627 15.4084C21.719 15.7138 21.7971 16.0866 21.7971 16.527V20H20.5116V16.7259C20.5116 16.3589 20.4169 16.0736 20.2275 15.87C20.0405 15.6641 19.7777 15.5611 19.4391 15.5611C19.2119 15.5611 19.0083 15.6108 18.8283 15.7102C18.6508 15.8073 18.5111 15.9482 18.4093 16.1328C18.3099 16.3175 18.2602 16.5412 18.2602 16.804ZM25.3067 20.1065C24.7741 20.1065 24.3124 19.9893 23.9218 19.755C23.5312 19.5206 23.2281 19.1927 23.0127 18.7713C22.7996 18.3499 22.6931 17.8575 22.6931 17.294C22.6931 16.7306 22.7996 16.237 23.0127 15.8132C23.2281 15.3894 23.5312 15.0604 23.9218 14.826C24.3124 14.5916 24.7741 14.4744 25.3067 14.4744C25.8394 14.4744 26.301 14.5916 26.6917 14.826C27.0823 15.0604 27.3841 15.3894 27.5972 15.8132C27.8126 16.237 27.9204 16.7306 27.9204 17.294C27.9204 17.8575 27.8126 18.3499 27.5972 18.7713C27.3841 19.1927 27.0823 19.5206 26.6917 19.755C26.301 19.9893 25.8394 20.1065 25.3067 20.1065ZM25.3138 19.0767C25.6027 19.0767 25.8441 18.9974 26.0383 18.8388C26.2324 18.6778 26.3768 18.4624 26.4715 18.1925C26.5686 17.9226 26.6171 17.6219 26.6171 17.2905C26.6171 16.9567 26.5686 16.6548 26.4715 16.3849C26.3768 16.1127 26.2324 15.8961 26.0383 15.7351C25.8441 15.5741 25.6027 15.4936 25.3138 15.4936C25.0179 15.4936 24.7717 15.5741 24.5752 15.7351C24.3811 15.8961 24.2355 16.1127 24.1384 16.3849C24.0437 16.6548 23.9964 16.9567 23.9964 17.2905C23.9964 17.6219 24.0437 17.9226 24.1384 18.1925C24.2355 18.4624 24.3811 18.6778 24.5752 18.8388C24.7717 18.9974 25.0179 19.0767 25.3138 19.0767ZM29.8009 20L28.2597 14.5455H29.5701L30.5289 18.3807H30.5786L31.5587 14.5455H32.8549L33.835 18.3594H33.8883L34.8329 14.5455H36.1468L34.602 20H33.2633L32.2405 16.3139H32.166L31.1432 20H29.8009ZM36.8643 20V14.5455H38.1499V20H36.8643ZM37.5106 13.7713C37.307 13.7713 37.1319 13.7038 36.9851 13.5689C36.8383 13.4316 36.7649 13.267 36.7649 13.0753C36.7649 12.8812 36.8383 12.7166 36.9851 12.5817C37.1319 12.4444 37.307 12.3757 37.5106 12.3757C37.7166 12.3757 37.8918 12.4444 38.0362 12.5817C38.183 12.7166 38.2564 12.8812 38.2564 13.0753C38.2564 13.267 38.183 13.4316 38.0362 13.5689C37.8918 13.7038 37.7166 13.7713 37.5106 13.7713ZM40.5773 16.804V20H39.2918V14.5455H40.5205V15.4723H40.5844C40.7098 15.1669 40.9099 14.9242 41.1845 14.7443C41.4615 14.5644 41.8036 14.4744 42.2108 14.4744C42.5872 14.4744 42.9151 14.5549 43.1945 14.7159C43.4762 14.8769 43.694 15.1101 43.8479 15.4155C44.0041 15.7209 44.0811 16.0914 44.0787 16.527V20H42.7932V16.7259C42.7932 16.3613 42.6985 16.076 42.5091 15.87C42.3221 15.6641 42.0628 15.5611 41.7314 15.5611C41.5065 15.5611 41.3064 15.6108 41.1313 15.7102C40.9584 15.8073 40.8223 15.9482 40.7229 16.1328C40.6258 16.3175 40.5773 16.5412 40.5773 16.804ZM47.5777 22.1591C47.116 22.1591 46.7195 22.0964 46.388 21.9709C46.0566 21.8478 45.7903 21.6821 45.589 21.4737C45.3878 21.2654 45.2481 21.0346 45.17 20.7812L46.3277 20.5007C46.3798 20.6072 46.4555 20.7126 46.5549 20.8168C46.6544 20.9233 46.7881 21.0109 46.9562 21.0795C47.1267 21.1506 47.3409 21.1861 47.599 21.1861C47.9636 21.1861 48.2654 21.0973 48.5045 20.9197C48.7436 20.7446 48.8632 20.4557 48.8632 20.0533V19.0199H48.7993C48.733 19.1525 48.6359 19.2886 48.5081 19.4283C48.3826 19.5679 48.2157 19.6851 48.0074 19.7798C47.8014 19.8745 47.5422 19.9219 47.2297 19.9219C46.8106 19.9219 46.4307 19.8236 46.0897 19.6271C45.7512 19.4283 45.4813 19.1323 45.2801 18.7393C45.0812 18.344 44.9818 17.8492 44.9818 17.255C44.9818 16.656 45.0812 16.1506 45.2801 15.7386C45.4813 15.3243 45.7524 15.0107 46.0933 14.7976C46.4342 14.5821 46.8142 14.4744 47.2332 14.4744C47.5528 14.4744 47.8156 14.5289 48.0216 14.6378C48.2299 14.7443 48.3956 14.8733 48.5187 15.0249C48.6418 15.174 48.7353 15.3149 48.7993 15.4474H48.8703V14.5455H50.138V20.0888C50.138 20.5552 50.0268 20.9411 49.8042 21.2464C49.5817 21.5518 49.2775 21.7803 48.8916 21.9318C48.5057 22.0833 48.0677 22.1591 47.5777 22.1591ZM47.5883 18.9134C47.8606 18.9134 48.0926 18.8471 48.2843 18.7145C48.4761 18.5819 48.6217 18.3913 48.7211 18.1428C48.8206 17.8942 48.8703 17.5959 48.8703 17.2479C48.8703 16.9046 48.8206 16.6039 48.7211 16.3459C48.6241 16.0878 48.4797 15.8878 48.2879 15.7457C48.0985 15.6013 47.8653 15.5291 47.5883 15.5291C47.3019 15.5291 47.0628 15.6037 46.871 15.7528C46.6792 15.902 46.5348 16.1068 46.4378 16.3672C46.3407 16.6252 46.2922 16.9188 46.2922 17.2479C46.2922 17.5817 46.3407 17.8741 46.4378 18.125C46.5372 18.3736 46.6828 18.5677 46.8745 18.7074C47.0687 18.8447 47.3066 18.9134 47.5883 18.9134ZM56.5199 12.7273V20H55.2024V14.0092H55.1598L53.4588 15.0959V13.8885L55.2663 12.7273H56.5199Z"
                fill="#181D2C"
              />
              <path
                d="M0.5 69C0.5 67.067 2.067 65.5 4 65.5H144C145.933 65.5 147.5 67.067 147.5 69V102C147.5 103.933 145.933 105.5 144 105.5H4C2.067 105.5 0.5 103.933 0.5 102V69Z"
                fill="white"
              />
              <path
                d="M0.5 69C0.5 67.067 2.067 65.5 4 65.5H144C145.933 65.5 147.5 67.067 147.5 69V102C147.5 103.933 145.933 105.5 144 105.5H4C2.067 105.5 0.5 103.933 0.5 102V69Z"
                fill="#F9FBFB"
              />
              <path
                d="M0.5 69C0.5 67.067 2.067 65.5 4 65.5H144C145.933 65.5 147.5 67.067 147.5 69V102C147.5 103.933 145.933 105.5 144 105.5H4C2.067 105.5 0.5 103.933 0.5 102V69Z"
                stroke="#D6D6D6"
              />
              <path
                d="M0 67C0 65.8954 0.895431 65 2 65V106C0.895431 106 0 105.105 0 104V67Z"
                fill="#2B59DA"
              />
              <path
                opacity="0.6"
                d="M14.6697 79.7266C14.6366 79.4164 14.4969 79.175 14.2507 79.0021C14.0069 78.8293 13.6896 78.7429 13.299 78.7429C13.0244 78.7429 12.7888 78.7843 12.5923 78.8672C12.3958 78.95 12.2455 79.0625 12.1413 79.2045C12.0372 79.3466 11.9839 79.5088 11.9815 79.6911C11.9815 79.8426 12.0159 79.974 12.0845 80.0852C12.1555 80.1965 12.2514 80.2912 12.3722 80.3693C12.4929 80.4451 12.6267 80.509 12.7734 80.5611C12.9202 80.6132 13.0682 80.657 13.2173 80.6925L13.8991 80.8629C14.1738 80.9268 14.4377 81.0133 14.6911 81.1222C14.9467 81.2311 15.1752 81.3684 15.3764 81.5341C15.58 81.6998 15.741 81.8999 15.8594 82.1342C15.9777 82.3686 16.0369 82.6432 16.0369 82.9581C16.0369 83.3842 15.928 83.7595 15.7102 84.0838C15.4924 84.4058 15.1776 84.6579 14.7656 84.8402C14.3561 85.0201 13.8601 85.1101 13.2777 85.1101C12.7119 85.1101 12.2206 85.0225 11.804 84.8473C11.3897 84.6721 11.0653 84.4164 10.831 84.0803C10.599 83.7441 10.4735 83.3345 10.4545 82.8516H11.7507C11.7696 83.1049 11.8478 83.3156 11.9851 83.4837C12.1224 83.6518 12.3011 83.7772 12.5213 83.8601C12.7438 83.9429 12.9924 83.9844 13.267 83.9844C13.5535 83.9844 13.8045 83.9418 14.0199 83.8565C14.2377 83.7689 14.4081 83.6482 14.5312 83.4943C14.6544 83.3381 14.7171 83.1558 14.7195 82.9474C14.7171 82.758 14.6615 82.6018 14.5526 82.4787C14.4437 82.3532 14.291 82.2491 14.0945 82.1662C13.9003 82.081 13.6731 82.0052 13.4126 81.9389L12.5852 81.7259C11.9863 81.572 11.5128 81.3388 11.1648 81.0263C10.8191 80.7114 10.6463 80.2936 10.6463 79.7727C10.6463 79.3442 10.7623 78.969 10.9943 78.647C11.2287 78.325 11.5471 78.0753 11.9496 77.8977C12.352 77.7178 12.8078 77.6278 13.3168 77.6278C13.8329 77.6278 14.285 77.7178 14.6733 77.8977C15.0639 78.0753 15.3705 78.3227 15.593 78.6399C15.8156 78.9548 15.9304 79.317 15.9375 79.7266H14.6697ZM18.2602 81.804V85H16.9747V77.7273H18.2318V80.4723H18.2957C18.4235 80.1645 18.6212 79.9219 18.8887 79.7443C19.1586 79.5644 19.5019 79.4744 19.9185 79.4744C20.2973 79.4744 20.6276 79.5537 20.9093 79.7124C21.191 79.871 21.4088 80.103 21.5627 80.4084C21.719 80.7138 21.7971 81.0866 21.7971 81.527V85H20.5116V81.7259C20.5116 81.3589 20.4169 81.0736 20.2275 80.87C20.0405 80.6641 19.7777 80.5611 19.4391 80.5611C19.2119 80.5611 19.0083 80.6108 18.8283 80.7102C18.6508 80.8073 18.5111 80.9482 18.4093 81.1328C18.3099 81.3175 18.2602 81.5412 18.2602 81.804ZM25.3067 85.1065C24.7741 85.1065 24.3124 84.9893 23.9218 84.755C23.5312 84.5206 23.2281 84.1927 23.0127 83.7713C22.7996 83.3499 22.6931 82.8575 22.6931 82.294C22.6931 81.7306 22.7996 81.237 23.0127 80.8132C23.2281 80.3894 23.5312 80.0604 23.9218 79.826C24.3124 79.5916 24.7741 79.4744 25.3067 79.4744C25.8394 79.4744 26.301 79.5916 26.6917 79.826C27.0823 80.0604 27.3841 80.3894 27.5972 80.8132C27.8126 81.237 27.9204 81.7306 27.9204 82.294C27.9204 82.8575 27.8126 83.3499 27.5972 83.7713C27.3841 84.1927 27.0823 84.5206 26.6917 84.755C26.301 84.9893 25.8394 85.1065 25.3067 85.1065ZM25.3138 84.0767C25.6027 84.0767 25.8441 83.9974 26.0383 83.8388C26.2324 83.6778 26.3768 83.4624 26.4715 83.1925C26.5686 82.9226 26.6171 82.6219 26.6171 82.2905C26.6171 81.9567 26.5686 81.6548 26.4715 81.3849C26.3768 81.1127 26.2324 80.8961 26.0383 80.7351C25.8441 80.5741 25.6027 80.4936 25.3138 80.4936C25.0179 80.4936 24.7717 80.5741 24.5752 80.7351C24.3811 80.8961 24.2355 81.1127 24.1384 81.3849C24.0437 81.6548 23.9964 81.9567 23.9964 82.2905C23.9964 82.6219 24.0437 82.9226 24.1384 83.1925C24.2355 83.4624 24.3811 83.6778 24.5752 83.8388C24.7717 83.9974 25.0179 84.0767 25.3138 84.0767ZM29.8009 85L28.2597 79.5455H29.5701L30.5289 83.3807H30.5786L31.5587 79.5455H32.8549L33.835 83.3594H33.8883L34.8329 79.5455H36.1468L34.602 85H33.2633L32.2405 81.3139H32.166L31.1432 85H29.8009ZM36.8643 85V79.5455H38.1499V85H36.8643ZM37.5106 78.7713C37.307 78.7713 37.1319 78.7038 36.9851 78.5689C36.8383 78.4316 36.7649 78.267 36.7649 78.0753C36.7649 77.8812 36.8383 77.7166 36.9851 77.5817C37.1319 77.4444 37.307 77.3757 37.5106 77.3757C37.7166 77.3757 37.8918 77.4444 38.0362 77.5817C38.183 77.7166 38.2564 77.8812 38.2564 78.0753C38.2564 78.267 38.183 78.4316 38.0362 78.5689C37.8918 78.7038 37.7166 78.7713 37.5106 78.7713ZM40.5773 81.804V85H39.2918V79.5455H40.5205V80.4723H40.5844C40.7098 80.1669 40.9099 79.9242 41.1845 79.7443C41.4615 79.5644 41.8036 79.4744 42.2108 79.4744C42.5872 79.4744 42.9151 79.5549 43.1945 79.7159C43.4762 79.8769 43.694 80.1101 43.8479 80.4155C44.0041 80.7209 44.0811 81.0914 44.0787 81.527V85H42.7932V81.7259C42.7932 81.3613 42.6985 81.076 42.5091 80.87C42.3221 80.6641 42.0628 80.5611 41.7314 80.5611C41.5065 80.5611 41.3064 80.6108 41.1313 80.7102C40.9584 80.8073 40.8223 80.9482 40.7229 81.1328C40.6258 81.3175 40.5773 81.5412 40.5773 81.804ZM47.5777 87.1591C47.116 87.1591 46.7195 87.0964 46.388 86.9709C46.0566 86.8478 45.7903 86.6821 45.589 86.4737C45.3878 86.2654 45.2481 86.0346 45.17 85.7812L46.3277 85.5007C46.3798 85.6072 46.4555 85.7126 46.5549 85.8168C46.6544 85.9233 46.7881 86.0109 46.9562 86.0795C47.1267 86.1506 47.3409 86.1861 47.599 86.1861C47.9636 86.1861 48.2654 86.0973 48.5045 85.9197C48.7436 85.7446 48.8632 85.4557 48.8632 85.0533V84.0199H48.7993C48.733 84.1525 48.6359 84.2886 48.5081 84.4283C48.3826 84.5679 48.2157 84.6851 48.0074 84.7798C47.8014 84.8745 47.5422 84.9219 47.2297 84.9219C46.8106 84.9219 46.4307 84.8236 46.0897 84.6271C45.7512 84.4283 45.4813 84.1323 45.2801 83.7393C45.0812 83.344 44.9818 82.8492 44.9818 82.255C44.9818 81.656 45.0812 81.1506 45.2801 80.7386C45.4813 80.3243 45.7524 80.0107 46.0933 79.7976C46.4342 79.5821 46.8142 79.4744 47.2332 79.4744C47.5528 79.4744 47.8156 79.5289 48.0216 79.6378C48.2299 79.7443 48.3956 79.8733 48.5187 80.0249C48.6418 80.174 48.7353 80.3149 48.7993 80.4474H48.8703V79.5455H50.138V85.0888C50.138 85.5552 50.0268 85.9411 49.8042 86.2464C49.5817 86.5518 49.2775 86.7803 48.8916 86.9318C48.5057 87.0833 48.0677 87.1591 47.5777 87.1591ZM47.5883 83.9134C47.8606 83.9134 48.0926 83.8471 48.2843 83.7145C48.4761 83.5819 48.6217 83.3913 48.7211 83.1428C48.8206 82.8942 48.8703 82.5959 48.8703 82.2479C48.8703 81.9046 48.8206 81.6039 48.7211 81.3459C48.6241 81.0878 48.4797 80.8878 48.2879 80.7457C48.0985 80.6013 47.8653 80.5291 47.5883 80.5291C47.3019 80.5291 47.0628 80.6037 46.871 80.7528C46.6792 80.902 46.5348 81.1068 46.4378 81.3672C46.3407 81.6252 46.2922 81.9188 46.2922 82.2479C46.2922 82.5817 46.3407 82.8741 46.4378 83.125C46.5372 83.3736 46.6828 83.5677 46.8745 83.7074C47.0687 83.8447 47.3066 83.9134 47.5883 83.9134ZM53.5618 85V84.0483L56.0866 81.5732C56.3281 81.3293 56.5293 81.1127 56.6903 80.9233C56.8513 80.7339 56.9721 80.5504 57.0525 80.3729C57.133 80.1953 57.1733 80.0059 57.1733 79.8047C57.1733 79.575 57.1212 79.3786 57.017 79.2152C56.9129 79.0495 56.7696 78.9216 56.5873 78.8317C56.4051 78.7417 56.1979 78.6967 55.9659 78.6967C55.7268 78.6967 55.5173 78.7464 55.3373 78.8459C55.1574 78.9429 55.0177 79.0814 54.9183 79.2614C54.8212 79.4413 54.7727 79.6555 54.7727 79.9041H53.5192C53.5192 79.4425 53.6245 79.0412 53.8352 78.7003C54.0459 78.3594 54.3359 78.0954 54.7052 77.9084C55.0769 77.7214 55.5031 77.6278 55.9837 77.6278C56.4713 77.6278 56.8998 77.719 57.2692 77.9013C57.6385 78.0836 57.9249 78.3333 58.1285 78.6506C58.3345 78.9678 58.4375 79.33 58.4375 79.7372C58.4375 80.0095 58.3854 80.277 58.2812 80.5398C58.1771 80.8026 57.9936 81.0937 57.7308 81.4134C57.4704 81.733 57.1046 82.12 56.6335 82.5746L55.38 83.8494V83.8991H58.5476V85H53.5618Z"
                fill="#181D2C"
              />
              <g opacity="0.6">
                <path
                  d="M135.375 76.5H128.625C128.004 76.5 127.5 77.0037 127.5 77.625V84.375C127.5 84.9963 128.004 85.5 128.625 85.5H135.375C135.996 85.5 136.5 84.9963 136.5 84.375V77.625C136.5 77.0037 135.996 76.5 135.375 76.5Z"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M134.25 75.75V77.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M129.75 75.75V77.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M127.5 79.5H136.5"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <g opacity="0.6">
                <path
                  d="M135.375 11.5H128.625C128.004 11.5 127.5 12.0037 127.5 12.625V19.375C127.5 19.9963 128.004 20.5 128.625 20.5H135.375C135.996 20.5 136.5 19.9963 136.5 19.375V12.625C136.5 12.0037 135.996 11.5 135.375 11.5Z"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M134.25 10.75V12.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M129.75 10.75V12.25"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M127.5 14.5H136.5"
                  stroke="#181D2C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </svg>
        );
      }
      case Icons.INFO: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 8C8 9.0414 8 9.4586 8 10.5"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="8" cy="5" r="1" fill="#747475" />
          </svg>
        );
      }
      case Icons.CALENDAR: {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.25 6H6.75C5.7835 6 5 6.7835 5 7.75V18.25C5 19.2165 5.7835 20 6.75 20H17.25C18.2165 20 19 19.2165 19 18.25V7.75C19 6.7835 18.2165 6 17.25 6Z"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5 4.5V7.5"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.5 4.5V7.5"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 11H19"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.NOTIFICATION: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_36520_51260)">
              <path
                d="M8.49998 4.83301H5.99998C5.55795 4.83301 5.13403 5.0086 4.82147 5.32116C4.50891 5.63372 4.33331 6.05765 4.33331 6.49967V13.9997C4.33331 14.4417 4.50891 14.8656 4.82147 15.1782C5.13403 15.4907 5.55795 15.6663 5.99998 15.6663H13.5C13.942 15.6663 14.3659 15.4907 14.6785 15.1782C14.9911 14.8656 15.1666 14.4417 15.1666 13.9997V11.4997"
                stroke={color ?? secondaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.3333 8.16699C15.714 8.16699 16.8333 7.0477 16.8333 5.66699C16.8333 4.28628 15.714 3.16699 14.3333 3.16699C12.9526 3.16699 11.8333 4.28628 11.8333 5.66699C11.8333 7.0477 12.9526 8.16699 14.3333 8.16699Z"
                stroke={color ?? secondaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_36520_51260">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.DOCUMENT: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7998 1.89844V5.49844C11.7998 5.73713 11.8946 5.96605 12.0634 6.13483C12.2322 6.30362 12.4611 6.39844 12.6998 6.39844H16.2998"
              stroke="#252D44"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5002 18.0984H5.5002C5.02281 18.0984 4.56497 17.9088 4.2274 17.5712C3.88984 17.2337 3.7002 16.7758 3.7002 16.2984V3.69844C3.7002 3.22105 3.88984 2.76321 4.2274 2.42565C4.56497 2.08808 5.02281 1.89844 5.5002 1.89844H11.8002L16.3002 6.39844V16.2984C16.3002 16.7758 16.1106 17.2337 15.773 17.5712C15.4354 17.9088 14.9776 18.0984 14.5002 18.0984Z"
              stroke="#252D44"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 9.5H12.5"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M7.5 13.5H10.5"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      }
      case Icons.NOTES: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.8337 9.5V16.8333C13.8337 17.2754 13.6581 17.6993 13.3455 18.0118C13.0329 18.3244 12.609 18.5 12.167 18.5H2.83366C2.39163 18.5 1.96771 18.3244 1.65515 18.0118C1.34259 17.6993 1.16699 17.2754 1.16699 16.8333V5.16667C1.16699 4.72464 1.34259 4.30072 1.65515 3.98816C1.96771 3.67559 2.39163 3.5 2.83366 3.5H9.66699L11.3337 5.16667"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 14H9.13144L17.3515 5.77998C17.7667 5.36472 18 4.80152 18 4.21426C18 3.627 17.7667 3.0638 17.3515 2.64854C16.9362 2.23329 16.373 2 15.7857 2C15.1985 2 14.6353 2.23329 14.22 2.64854L6 10.8686V14Z"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.FEEDBACK: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_36520_49946)">
              <path
                d="M2.66699 18.2502V6.3335C2.66699 5.60415 2.95672 4.90468 3.47245 4.38895C3.98817 3.87323 4.68765 3.5835 5.41699 3.5835H14.5837C15.313 3.5835 16.0125 3.87323 16.5282 4.38895C17.0439 4.90468 17.3337 5.60415 17.3337 6.3335V11.8335C17.3337 12.5628 17.0439 13.2623 16.5282 13.778C16.0125 14.2938 15.313 14.5835 14.5837 14.5835H6.33366L2.66699 18.2502Z"
                stroke="#252D44"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 6.7915V8.62484"
                stroke={color ?? secondaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="9.99967" cy="11.3752" r="0.916667" fill={color ?? secondaryColor} />
            </g>
            <defs>
              <clipPath id="clip0_36520_49946">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.TIME: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 11.5L10 10V6.5"
              stroke={color ?? secondaryColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="10" cy="10" r="7" stroke={color ?? secondaryColor} strokeWidth="2" />
          </svg>
        );
      }
      case Icons.LINK: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_36520_47583)">
              <path
                d="M8.33398 11.6676C8.60555 11.9448 8.92969 12.165 9.28742 12.3153C9.64516 12.4656 10.0293 12.5431 10.4173 12.5431C10.8053 12.5431 11.1895 12.4656 11.5472 12.3153C11.9049 12.165 12.2291 11.9448 12.5007 11.6676L15.834 8.3343C16.3865 7.78176 16.6969 7.03237 16.6969 6.25097C16.6969 5.46956 16.3865 4.72017 15.834 4.16763C15.2815 3.6151 14.5321 3.30469 13.7507 3.30469C12.9692 3.30469 12.2199 3.6151 11.6673 4.16763L11.2507 4.5843"
                stroke="#252D44"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.6667 8.33246C11.3951 8.05529 11.0709 7.8351 10.7132 7.68478C10.3555 7.53446 9.97135 7.45703 9.58332 7.45703C9.19529 7.45703 8.81116 7.53446 8.45343 7.68478C8.0957 7.8351 7.77155 8.05529 7.49999 8.33246L4.16666 11.6658C3.61412 12.2183 3.30371 12.9677 3.30371 13.7491C3.30371 14.5305 3.61412 15.2799 4.16666 15.8325C4.71919 16.385 5.46859 16.6954 6.24999 16.6954C7.03139 16.6954 7.78079 16.385 8.33332 15.8325L8.74999 15.4158"
                stroke="#252D44"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_36520_47583">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <div testid={testid} onClick={onClick} className={classNames(styles.icons, className)}>
      {getIcons()}
    </div>
  );
};

Icons.CONDO = 'condo';
Icons.EDIT = 'edit';
Icons.COPY = 'copy';
Icons.DELETE = 'delete';
Icons.ADD = 'add';
Icons.CHECKMARK = 'checkmark';
Icons.SHOWINGS = 'showings';
Icons.BUFFER_BTW_SHOWINGS = 'bufferBtwShowings';
Icons.INFO = 'info';
Icons.REMOVE = 'remove';
Icons.CALENDAR = 'calendar';
Icons.NOTIFICATION = 'notification';
Icons.DOCUMENT = 'document';
Icons.NOTES = 'notes';
Icons.FEEDBACK = 'feedback';
Icons.TIME = 'time';
Icons.LINK = 'link';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  testid: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
};

Icons.defaultProps = {
  className: '',
  variant: '',
  testid: undefined,
  onClick: () => {},
};
